import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { reportFrontendError } from './api/apiClient';

// ── Global error listeners ───────────────────────────────────────────────
// Catch synchronous errors React's ErrorBoundary doesn't see (event
// handler bugs, third-party script crashes) + unhandled promise
// rejections (forgotten try/catch around async APIs). Both fire-and-
// forget to the telemetry endpoint; failures are swallowed inside
// reportFrontendError so we never recurse.
//
// Don't preventDefault — let the browser keep its default behaviour
// (console.error / red devtools entry). We just add a Slack notification.
window.addEventListener('error', (e) => {
  reportFrontendError(e.message || 'window.onerror', {
    stack:  e.error?.stack,
    source: `window.onerror @ ${e.filename || 'unknown'}:${e.lineno || 0}`,
  });
});
window.addEventListener('unhandledrejection', (e) => {
  const reason = e.reason;
  const message = (reason && (reason.message || String(reason))) || 'Unhandled promise rejection';
  reportFrontendError(message, {
    stack:  reason?.stack,
    source: 'unhandledrejection',
  });
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
